exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barcode-wrapper>:first-child{font-size:22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6458b314","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SparePart/SparePartDetail.vue
// module id = 913
// module chunks = 0